import get from 'lodash-es/get';
import noop from 'lodash-es/noop';
import { deleteImportById, getImportDataById, getImportDetails, uploadMapDataFile } from '../services/udapi/imports';


export default {
  namespace: 'dataManager',
  state: {
    acceptedFileConents: null,
    acceptedFiles: [],
    fileSizeError: false,
    importedFeatures: [],
    importedCollections: [],
    importError: null,
    isExporting: false,
    isImporting: false,
    isSavingImport: false,
    lastSuccessfulUploadId: null,
  },
  effects: {
    *deleteLatestUpload({ callback = noop }, { call, select }) {
      const uploadId = yield select((model) => model.dataManager.lastSuccessfulUploadId);
      if (!uploadId) {
        callback(null);
      }

      let delRes = yield call(deleteImportById, uploadId);

      if (delRes.success) {
        callback(delRes);
      } else {
        console.error('ERROR: Unable to delete upload', delRes);
        callback(null);
      }
    },
    *submitFile({ callback = noop }, { call, put, select }) {
      const fileContents = yield select((model) => model.dataManager.acceptedFileContents);
      const response = yield call(uploadMapDataFile, fileContents);

      if (response.success && response.data.uploadId) {
        const uploadId = response.data.uploadId;
        yield put({ type: 'setSuccessfulUploadId', payload: uploadId });
        callback(uploadId, null);
      } else {
        const message = get(response.data.response, ['data', 'result', 'message'], 'There was an issue while importing your file')
        yield put({ type: 'setImportError', payload: message });
        callback(null, message);
      }
    },
    pollForImportDataEffect: [
      function* ({ callback, payload: uploadId }, { call, put }) {
        const response = yield call(getImportDetails, uploadId);

        if (response.success) {
          // validation of file type
          if (response.data.valid === false) {
            yield put({ type: 'setImportError', payload: response.data.message });
            callback(null, response.data.message);
          } else if (response.data.completed) {
            // poll until completed is true, then get all features by their uploadId
            let importRes = yield call(getImportDataById, uploadId);

            if (importRes.success) {
              yield put({ type: 'setContentBuffer', payload: importRes.data });
            } else {
              yield put({ type: 'setImportError', payload: importRes.data.message });
            }
            callback(importRes.data.length);
            /* TODO: Change condition when UDAPI adds a new column for failed imports */
          } else if (![null, 'OK'].includes(response.data.message)) {
            yield put({ type: 'setImportError', payload: response.data.message });
            callback(null, response.data.message);
          }
        } else {
          yield put({ type: 'setImportError', payload: response.data.message });
          callback(null, response.data.message);
        }
      },
      { type: 'poll', delay: 2000 }
    ]
  },
  reducers: {
    setIsExporting(state, { payload: isExporting }) {
      return {
        ...state,
        isExporting
      };
    },
    clearImportFile(state, action) {
      return {
        ...state,
        acceptedFileContents: null,
        acceptedFiles: [],
        fileSizeError: false,
        importError: null,
        isImporting: false,
      };

    },
    setIsImporting(state, { payload: isImporting }) {
      return {
        ...state,
        isImporting
      };
    },
    setIsSavingImport(state, { payload: status }) {
      return {
        ...state,
        isSavingImport: status
      };
    },
    setSuccessfulUploadId(state, { payload: uploadId }) {
      return {
        ...state,
        lastSuccessfulUploadId: uploadId
      };
    },
    setImportError(state, { payload: error }) {
      return {
        ...state,
        importError: error
      };
    },
    showFilesizeError(state, payload) {
      return {
        ...state,
        fileSizeError: true
      };
    },
    addFileContents(state, { payload: fileContents }) {
      return {
        ...state,
        acceptedFileContents: fileContents
      };
    },
    updateAcceptedFiles(state, { payload: files }) {
      return {
        ...state,
        acceptedFiles: files,
        fileSizeError: false,
      };
    },
    setContentBuffer(state, { payload: list }) {
      const importData = {
        collections: [],
        features: []
      }
      list.forEach(li => {
        if (li.type === 'collection') importData.collections.push(li)
        else importData.features.push(li)
      })
      return {
        ...state,
        importedCollections: importData.collections,
        importedFeatures: importData.features,
      };
    },
    reset(state, payload) {
      return {
        ...state,
        acceptedFiles: [],
        fileSizeError: false,
        importError: null,
        importedFeatures: [],
        acceptedFileContents: null,
        lastSuccessfulUploadId: null,
      };
    }
  }
};